import React from 'react';
import './Section4.css';

const Section4 = () => {
  return (
    <section className="section4">
      {/* LEFT TITLE COLUMN */}
      <div className="section4-left">
        <h1 className="section4-title">Goals</h1>
      </div>

      {/* RIGHT GOALS LIST */}
      <div className="section4-right">
        <div className="goal-item">
          <p className="goal-number">01</p>
          <div className="goal-text">
            <p>
              A <strong>dedicated platform</strong><br />
              to help Candadian brands achieve more sucess
            </p>
          </div>
        </div>
        <hr />

        <div className="goal-item">
          <p className="goal-number">02</p>
          <div className="goal-text">
            <p>
              <strong>Affordable tools</strong><br />
              to manage inventory, analytics, and customer engagement
            </p>
          </div>
        </div>
        <hr />

        <div className="goal-item">
          <p className="goal-number">03</p>
          <div className="goal-text">
            <p>
              A <strong>supportive ecosystem</strong><br />
              that encourages Canadians to buy local
            </p>
          </div>
        </div>
        <hr />

        <div className="goal-item">
          <p className="goal-number">04</p>
          <div className="goal-text">
            <p>
              A <strong>vibrant community</strong><br />
              of makers, vendors, and customers united under one roof
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section4;
